@layer module {
.error-fallback-wrapper {
            display: flex;
            align-items: center;
            justify-content: center;
    }

.error-fallback-content {
            display: flex;
            flex-flow: column nowrap;
            align-items: center;
            justify-content: center;
            text-align: center;
    }

.error-fallback-content button {
            cursor: pointer;
            outline: none;
            border: none;
    }
} // layer module










@layer app {
.error-fallback-wrapper {
            margin-top: $size-80;
    }

.error-fallback-content {
            max-width: $size-500;
            width: 100%;
            border-radius: $size-10;
            padding: $size-30;
    }

.error-fallback-content img {
            width: $size-66;
            height: $size-38;
    }

.error-fallback-content button {
            width: 100%;
            max-width: $size-300;
            padding: $size-15;
            border-radius: $size-5;
    }

.error-fallback-content {
            background-color: var(--banky-white);
            font-size: var(--font-size-lg);
    }

.error-fallback-content button {
            color: var(--banky-white);
            background: var(--banky-radical-red);
            box-shadow: var(--shadow-error-fallback);
    }
} // layer app
